module.exports = __webpack_public_path__ + "img/carousel3.c157c961.png";